import { httpClient } from '@/shared/api/httpClient';
import { classifyApiError } from '@/shared/api/classifyApiError';
import type { BiometricDeletionRepository } from '@/modules/admin/domain/repositories/BiometricDeletionRepository';
import { BiometricDeletionError } from '@/modules/admin/domain/errors/BiometricDeletionError';

/**
 * HTTP adapter for BiometricDeletionRepository.
 *
 * Calls the remote DELETE endpoints for facial embedding and NFC biometric records.
 * 404 responses are mapped to void (idempotent — resource already deleted).
 * Any other error is wrapped in BiometricDeletionError.
 *
 * Change: nueva-seccion-de-borrado-perfiles-en-administracion-empleados
 */
export class HttpBiometricDeletionRepository implements BiometricDeletionRepository {
  async deleteFacialEmbedding(idPerson: number): Promise<void> {
    try {
      // Path namespace is `/person/` — parameter MUST be id_person.
      // (Backend returns CL410 EMBED_NOT_FOUND when id_entity is sent instead,
      // because the embedding row is keyed by id_person on the server side.)
      await httpClient.delete(`/v1/clock/app/person/${idPerson}/embed`);
    } catch (err: unknown) {
      const classified = classifyApiError(err);
      if (classified.kind === 'not_found') return;
      throw new BiometricDeletionError(classified.kind, classified.message);
    }
  }

  async deleteNfcBiometric(idEntity: number, idEntityBiometric: number): Promise<void> {
    try {
      await httpClient.delete(`/v1/clock/app/entity/${idEntity}/biometric/${idEntityBiometric}`);
    } catch (err: unknown) {
      const classified = classifyApiError(err);
      if (classified.kind === 'not_found') return;
      throw new BiometricDeletionError(classified.kind, classified.message);
    }
  }
}
